'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlertLink = function (_React$Component) {
  (0, _inherits3.default)(AlertLink, _React$Component);

  function AlertLink() {
    (0, _classCallCheck3.default)(this, AlertLink);
    return (0, _possibleConstructorReturn3.default)(this, (AlertLink.__proto__ || (0, _getPrototypeOf2.default)(AlertLink)).apply(this, arguments));
  }

  (0, _createClass3.default)(AlertLink, [{
    key: 'render',
    value: function render() {
      var props = (0, _extends3.default)({}, this.props);
      props.className = (0, _classnames2.default)('alert-link', props.className);

      return _react2.default.createElement('a', props);
    }
  }]);
  return AlertLink;
}(_react2.default.Component);

exports.default = AlertLink;


//////////////////
// WEBPACK FOOTER
// ./~/@sketchpixy/rubix/lib/AlertLink.js
// module id = 601
// module chunks = 0